import i18n from 'i18n';
import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

const fields: GenericFormItem[] = [
  {
    gridXs: 12,
    label: i18n.t('PASSWORD_KEY'),
    stateKey: 'password',
    type: 'password',
    validateOnChange: true,
  },
  {
    gridXs: 12,
    label: i18n.t('AUTHENTICATION_CODE_KEY'),
    stateKey: 'code',
    type: 'text',
    mask: '9 9 9   9 9 9',
    validateOnChange: true,
  },
];

export default fields;
